import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e0f5e1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-user-layout" }

import BaseBox from '@/components/layout/BaseBox.vue';
import BaseFlex from '@/components/layout/BaseFlex.vue';
import { useRouter } from 'vue-router';
import CreateNewUserForm from '@/forms/CreateNewUserForm.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { push: pushRoute } = useRouter();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseFlex, {
      row: "",
      "row-gap": "15px",
      "col-gap": "15px",
      wrap: "nowrap"
    }, {
      default: _withCtx(() => [
        _createVNode(BaseFlex, {
          col: "",
          class: "new-user-box"
        }, {
          default: _withCtx(() => [
            _createVNode(BaseBox, { title: "Nový uživatel" }, {
              default: _withCtx(() => [
                _createVNode(CreateNewUserForm)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})